"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgRockfalls(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 -4 18 24" }, props),
        React.createElement("path", { d: "M3 .008l3.336 1.47.678 2.86c1.11.517 1.503 1.037 2.633 1.562v2.922c1.049.762 3.41 1.005 3.173 2.9 1.606-.43 2.554.539 3.618 1.212 1.3.821 2.584 1.664 3.874 2.501.188.122.366.26.668.474-.311.044-.481.088-.651.088-5.615.004-11.23.004-16.844 0-.162 0-.323-.038-.485-.059zM19.286 10L21 11.091 19.718 13 18 11.116zm-4.917-3L17 8.7V11l-4-1.61zM11.61 0L16 1.526V6h-4.94L9 2.47 11.611 0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Rockfalls')(SvgRockfalls);
//# sourceMappingURL=Rockfalls.js.map